/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * API V1
 * OpenAPI spec version: v1
 */
export interface Error {
  message: string;
  code: number;
}

export interface Result {
  result: boolean;
}

export interface TeamUserPermissions {
  read: boolean;
  write: boolean;
  invite: boolean;
  billing: boolean;
}

/**
 * @nullable
 */
export type AvatarUrls = {
  "48"?: string;
  "64"?: string;
  "120"?: string;
} | null;

export interface TeamItemUserPermissions {
  read: boolean;
  write: boolean;
  comment?: boolean;
}

export type DocumentPermissionsTypename =
  (typeof DocumentPermissionsTypename)[keyof typeof DocumentPermissionsTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentPermissionsTypename = {
  DocumentPermissions: "DocumentPermissions",
} as const;

export interface DocumentPermissions {
  uid: string;
  typename: DocumentPermissionsTypename;
  userPermissions: TeamItemUserPermissions;
}

export interface TeamCoursePreview {
  uid: string;
  schoolUid: string;
  memberAvatars: AvatarUrls[];
}

export type DocumentTypename = (typeof DocumentTypename)[keyof typeof DocumentTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentTypename = {
  Document: "Document",
} as const;

export interface Document {
  typename: DocumentTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  slug: string | null;
  /** @nullable */
  description?: string | null;
  publicWrite: boolean;
  publicRead: boolean;
  locked?: boolean;
  canToggleLock?: boolean;
  isDuplicating?: boolean;
  duplicationIncomplete?: boolean;
  importInProgress?: boolean;
  /** @nullable */
  team?: TeamShort;
  /** @nullable */
  firstImageUrl?: string | null;
  createdAt: string;
  userPermissions: TeamItemUserPermissions;
  unreadMessagesCount: number;
  /** @nullable */
  mentions?: UserShort[] | null;
  /** @nullable */
  permissionRequestScope?: string | null;
}

export type DocumentShortTypename =
  (typeof DocumentShortTypename)[keyof typeof DocumentShortTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentShortTypename = {
  DocumentShort: "DocumentShort",
} as const;

/**
 * Trimmed Document payload used inside team-tree responses
 */
export interface DocumentShort {
  typename: DocumentShortTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  slug: string | null;
  locked?: boolean;
  canToggleLock?: boolean;
  isDuplicating?: boolean;
  duplicationIncomplete?: boolean;
  importInProgress?: boolean;
  userPermissions: TeamItemUserPermissions;
  unreadMessagesCount: number;
  createdAt: string;
}

export type BaseDocumentBroadcastTypename =
  (typeof BaseDocumentBroadcastTypename)[keyof typeof BaseDocumentBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseDocumentBroadcastTypename = {
  DocumentShort: "DocumentShort",
} as const;

export interface BaseDocumentBroadcast {
  typename: BaseDocumentBroadcastTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  isDuplicating: boolean;
  duplicationIncomplete: boolean;
  importInProgress: boolean;
  isDeleted: boolean;
}

export type UserSpecificDocumentBroadcastTypename =
  (typeof UserSpecificDocumentBroadcastTypename)[keyof typeof UserSpecificDocumentBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSpecificDocumentBroadcastTypename = {
  Document: "Document",
} as const;

export interface UserSpecificDocumentBroadcast {
  typename: UserSpecificDocumentBroadcastTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  unreadMessagesCount: number;
  /** @nullable */
  permissionRequestScope?: string | null;
  isDuplicating: boolean;
  duplicationIncomplete: boolean;
  importInProgress: boolean;
  isDeleted: boolean;
}

export type DocumentSearchResultTypename =
  (typeof DocumentSearchResultTypename)[keyof typeof DocumentSearchResultTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentSearchResultTypename = {
  DocumentSearchResult: "DocumentSearchResult",
} as const;

export interface DocumentSearchResult {
  typename: DocumentSearchResultTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  searchDoc?: string | null;
  /** @nullable */
  team?: TeamShort;
}

export type DocumentPermissionTypename =
  (typeof DocumentPermissionTypename)[keyof typeof DocumentPermissionTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentPermissionTypename = {
  DocumentPermission: "DocumentPermission",
} as const;

export interface DocumentPermission {
  typename: DocumentPermissionTypename;
  uid: string;
  /** @nullable */
  team?: TeamShort;
  /** @nullable */
  email?: string | null;
  document: UserSpecificDocumentBroadcast;
  scope: string;
  kind: string;
  confirmed: boolean;
}

export type FolderTypename = (typeof FolderTypename)[keyof typeof FolderTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderTypename = {
  Folder: "Folder",
} as const;

export type FolderFilesItem = Folder | DocumentShort;

export interface Folder {
  typename: FolderTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  createdAt: string;
  files?: FolderFilesItem[];
  userPermissions: TeamItemUserPermissions;
  /** @nullable */
  publicAccessRights?: TeamItemUserPermissions;
  isDuplicating: boolean;
}

export type BaseFolderBroadcastTypename =
  (typeof BaseFolderBroadcastTypename)[keyof typeof BaseFolderBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseFolderBroadcastTypename = {
  Folder: "Folder",
} as const;

export interface BaseFolderBroadcast {
  typename: BaseFolderBroadcastTypename;
  uid: string;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  publicScope?: TeamItemUserPermissions;
  isDuplicating: boolean;
  isDeleted: boolean;
}

export type MessageTypename = (typeof MessageTypename)[keyof typeof MessageTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageTypename = {
  Message: "Message",
} as const;

export type MessageMeta = { [key: string]: string };

export interface Message {
  typename: MessageTypename;
  uid: string;
  /** @nullable */
  body?: string | null;
  meta: MessageMeta;
  user: UserShort;
  mentions?: UserShort[];
  reactions?: Reaction[];
  createdAt: string;
  /** @nullable */
  editedAt?: string | null;
  isDeleted?: boolean;
  cursor: string;
  files?: Upload[];
}

export type MessageNotificationTypename =
  (typeof MessageNotificationTypename)[keyof typeof MessageNotificationTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageNotificationTypename = {
  MessageNotification: "MessageNotification",
} as const;

/**
 * @nullable
 */
export type MessageNotificationDocument = {
  uid: string;
  /** @nullable */
  title: string | null;
} | null;

export interface MessageNotification {
  typename: MessageNotificationTypename;
  /** @nullable */
  body: string | null;
  chatUid: string;
  messageUid: string;
  /** @nullable */
  chatTitle: string | null;
  /** @nullable */
  document: MessageNotificationDocument;
}

export type MentionTypename = (typeof MentionTypename)[keyof typeof MentionTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MentionTypename = {
  Mention: "Mention",
} as const;

export type MentionSourceType = (typeof MentionSourceType)[keyof typeof MentionSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MentionSourceType = {
  Document: "Document",
  Message: "Message",
} as const;

/**
 * @nullable
 */
export type MentionDocument = {
  uid: string;
  /** @nullable */
  title: string | null;
  /** @nullable */
  teamPermalink: string | null;
} | null;

export interface Mention {
  typename: MentionTypename;
  sourceNodeId: string;
  sourceType: MentionSourceType;
  /** @nullable */
  chatUid: string | null;
  /** @nullable */
  messageUid: string | null;
  /** @nullable */
  body: string | null;
  /** @nullable */
  document: MentionDocument;
}

export type ChatTypename = (typeof ChatTypename)[keyof typeof ChatTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatTypename = {
  Chat: "Chat",
} as const;

export type ChatKind = (typeof ChatKind)[keyof typeof ChatKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatKind = {
  collective: "collective",
  personal: "personal",
  direct: "direct",
} as const;

export type ChatMeta = { [key: string]: string };

export interface Chat {
  typename: ChatTypename;
  uid: string;
  kind: ChatKind;
  meta: ChatMeta;
  messages: Message[];
  subscribers: UserShort[];
  messagesCount: number;
  unreadMessagesCount: number;
  /** @nullable */
  title?: string | null;
  createdAt: string;
  /** @nullable */
  teamUid?: string | null;
}

export type BaseChatBroadcastTypename =
  (typeof BaseChatBroadcastTypename)[keyof typeof BaseChatBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatBroadcastTypename = {
  Chat: "Chat",
} as const;

export interface BaseChatBroadcast {
  typename: BaseChatBroadcastTypename;
  uid: string;
  messagesCount: number;
  /** @nullable */
  title?: string | null;
}

export type UserSpecificChatBroadcastTypename =
  (typeof UserSpecificChatBroadcastTypename)[keyof typeof UserSpecificChatBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSpecificChatBroadcastTypename = {
  Chat: "Chat",
} as const;

export interface UserSpecificChatBroadcast {
  typename: UserSpecificChatBroadcastTypename;
  uid: string;
  messagesCount: number;
  unreadMessagesCount: number;
  /** @nullable */
  title?: string | null;
}

export type ChatShortTypename = (typeof ChatShortTypename)[keyof typeof ChatShortTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatShortTypename = {
  ChatShort: "ChatShort",
} as const;

export type ChatShortMeta = { [key: string]: string };

export interface ChatShort {
  typename: ChatShortTypename;
  uid: string;
  meta: ChatShortMeta;
  messagesCount: number;
  unreadMessagesCount: number;
  /** @nullable */
  title?: string | null;
}

/**
 * personal: the owner's own team; course: the team behind a course; regular: any other team.
 */
export type TeamKind = (typeof TeamKind)[keyof typeof TeamKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamKind = {
  personal: "personal",
  course: "course",
  regular: "regular",
} as const;

export type TeamTypename = (typeof TeamTypename)[keyof typeof TeamTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamTypename = {
  Team: "Team",
} as const;

export interface Team {
  typename: TeamTypename;
  uid: string;
  /** @nullable */
  title: string | null;
  /** @nullable */
  bio: string | null;
  permalink: string;
  /**
   * Deprecated: check `kind` instead.
   * @deprecated
   */
  personal: boolean;
  kind: TeamKind;
  userPermissions: TeamUserPermissions;
  /** @nullable */
  avatarUrls: AvatarUrls;
  following: boolean;
  followersCount: number;
  unreadMessagesCount: number;
  membersCount: number;
  /** @nullable */
  ownerUid?: string | null;
  /** @nullable */
  unlisted?: Folder;
  /** @nullable */
  root: Folder;
  /** @nullable */
  drafts: Folder;
  /** @nullable */
  trash: Folder;
  published: Folder;
  /** @nullable */
  shared?: DocumentShort[] | null;
}

export type TeamShortTypename = (typeof TeamShortTypename)[keyof typeof TeamShortTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamShortTypename = {
  TeamShort: "TeamShort",
} as const;

export interface TeamShort {
  typename: TeamShortTypename;
  uid: string;
  /** @nullable */
  title: string | null;
  /** @nullable */
  bio: string | null;
  permalink: string;
  /**
   * Deprecated: check `kind` instead.
   * @deprecated
   */
  personal: boolean;
  kind: TeamKind;
  /** @nullable */
  userPermissions: TeamUserPermissions;
  avatarUrls: AvatarUrls;
  followersCount: number;
  unreadMessagesCount: number;
  membersCount: number;
  /** @nullable */
  ownerUid?: string | null;
}

export type TeamBaseTypename = (typeof TeamBaseTypename)[keyof typeof TeamBaseTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamBaseTypename = {
  Team: "Team",
} as const;

export interface TeamBase {
  typename: TeamBaseTypename;
  uid: string;
  /** @nullable */
  title: string | null;
  permalink: string;
}

export type BaseTeamBroadcastTypename =
  (typeof BaseTeamBroadcastTypename)[keyof typeof BaseTeamBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseTeamBroadcastTypename = {
  Team: "Team",
} as const;

export interface BaseTeamBroadcast {
  typename: BaseTeamBroadcastTypename;
  uid: string;
}

export type UserSpecificTeamBroadcastTypename =
  (typeof UserSpecificTeamBroadcastTypename)[keyof typeof UserSpecificTeamBroadcastTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSpecificTeamBroadcastTypename = {
  Team: "Team",
} as const;

export interface UserSpecificTeamBroadcast {
  typename: UserSpecificTeamBroadcastTypename;
  uid: string;
  unreadMessagesCount: number;
}

export type TeamBranchTypename = (typeof TeamBranchTypename)[keyof typeof TeamBranchTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamBranchTypename = {
  TeamBranch: "TeamBranch",
} as const;

export type TeamBranchBranch = BaseFolderBroadcast | BaseDocumentBroadcast;

export type TeamBranchParent = BaseFolderBroadcast | BaseTeamBroadcast;

export interface TeamBranch {
  typename: TeamBranchTypename;
  position: number;
  branch: TeamBranchBranch;
  parent: TeamBranchParent;
}

export type FollowTypename = (typeof FollowTypename)[keyof typeof FollowTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FollowTypename = {
  Follow: "Follow",
} as const;

export interface Follow {
  typename: FollowTypename;
  team: TeamShort;
  follower: UserShort;
}

export type MembershipTypename = (typeof MembershipTypename)[keyof typeof MembershipTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembershipTypename = {
  Membership: "Membership",
} as const;

export interface Membership {
  typename: MembershipTypename;
  id: string;
  user: UserShort;
  accessLevel: string;
}

export type MembershipWithTeamAllOf = {
  entity: TeamShort;
};

export type MembershipWithTeam = Membership & MembershipWithTeamAllOf;

export type NotificationTypename = (typeof NotificationTypename)[keyof typeof NotificationTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTypename = {
  Notification: "Notification",
} as const;

/**
 * @nullable
 */
export type NotificationEntity =
  | Invite
  | MembershipWithTeam
  | DocumentPermission
  | MessageNotification
  | Mention
  | null;

export interface Notification {
  typename: NotificationTypename;
  id: string;
  /** @nullable */
  entity?: NotificationEntity;
  sender: UserShort;
  recipient: User;
  createdAt: string;
  isDeleted: boolean;
  isRead: boolean;
  cursor: string;
}

export type InviteTypename = (typeof InviteTypename)[keyof typeof InviteTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteTypename = {
  Invite: "Invite",
} as const;

export interface Invite {
  typename: InviteTypename;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  user?: UserShort;
  /** @nullable */
  sender?: UserShort;
  team?: TeamShort;
  token: string;
  kind: string;
}

export type ReferralTypename = (typeof ReferralTypename)[keyof typeof ReferralTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferralTypename = {
  Referral: "Referral",
} as const;

export interface Referral {
  typename: ReferralTypename;
  /** @nullable */
  user?: UserShort;
  token: string;
  /** @nullable */
  info?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  signupsCount: number;
  /** @nullable */
  creator?: UserShort;
  isDeleted: boolean;
}

export type ReactionTypename = (typeof ReactionTypename)[keyof typeof ReactionTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReactionTypename = {
  Reaction: "Reaction",
} as const;

export interface Reaction {
  typename: ReactionTypename;
  emoji: string;
  count: number;
  users: UserShort[];
}

export type SubscriptionPlanTypename =
  (typeof SubscriptionPlanTypename)[keyof typeof SubscriptionPlanTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanTypename = {
  SubscriptionPlan: "SubscriptionPlan",
} as const;

export type SubscriptionPlanKind = (typeof SubscriptionPlanKind)[keyof typeof SubscriptionPlanKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanKind = {
  personal: "personal",
  team: "team",
} as const;

export type SubscriptionPlanInterval =
  (typeof SubscriptionPlanInterval)[keyof typeof SubscriptionPlanInterval];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanInterval = {
  month: "month",
} as const;

export interface SubscriptionPlan {
  typename: SubscriptionPlanTypename;
  uid: string;
  name: string;
  kind: SubscriptionPlanKind;
  interval: SubscriptionPlanInterval;
  current: boolean;
  stripePriceId: string;
  aiCredits: number;
  priceCents: number;
}

export type SubscriptionTypename = (typeof SubscriptionTypename)[keyof typeof SubscriptionTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionTypename = {
  Subscription: "Subscription",
} as const;

/**
 * @nullable
 */
export type SubscriptionSubscriptionPlan = SubscriptionPlan | null;

export interface Subscription {
  typename: SubscriptionTypename;
  /** Stripe subscription id. */
  uid: string;
  /** Stripe subscription status, e.g. `active` or `trialing`. */
  status: string;
  /** @nullable */
  currentPeriodStart: string | null;
  /** @nullable */
  currentPeriodEnd: string | null;
  /**
   * Set once the subscription is canceled; it stays active until then.
   * @nullable
   */
  endsAt: string | null;
  /** @nullable */
  subscriptionPlan: SubscriptionSubscriptionPlan;
}

export interface AiCreditBalance {
  granted: number;
  used: number;
  remaining: number;
  /**
   * When the pool's credits expire: the end of the billing period for a subscription, the end of the day for the free tier.
   * @nullable
   */
  expiresAt: string | null;
}

export type UploadTypename = (typeof UploadTypename)[keyof typeof UploadTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadTypename = {
  Upload: "Upload",
} as const;

export interface Upload {
  typename: UploadTypename;
  key: string;
  filename: string;
  contentType: string;
  byteSize: number;
  signedUrl: string;
  /** @nullable */
  width?: number | null;
  /** @nullable */
  height?: number | null;
}

export type DirectUploadTypename = (typeof DirectUploadTypename)[keyof typeof DirectUploadTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectUploadTypename = {
  DirectUpload: "DirectUpload",
} as const;

export type DirectUploadHeaders = { [key: string]: string };

export interface DirectUpload {
  typename: DirectUploadTypename;
  key: string;
  contentType: string;
  url: string;
  headers: DirectUploadHeaders;
}

export type UserTypename = (typeof UserTypename)[keyof typeof UserTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTypename = {
  User: "User",
} as const;

export interface User {
  typename: UserTypename;
  name: string;
  uid: string;
  email: string;
  username: string;
  avatarUrls?: AvatarUrls;
  unreadNotificationsCount: number;
}

export type CurrentUserTypename = (typeof CurrentUserTypename)[keyof typeof CurrentUserTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentUserTypename = {
  User: "User",
} as const;

/**
 * The current user's own record; includes private fields other user payloads omit.
 */
export interface CurrentUser {
  typename: CurrentUserTypename;
  name: string;
  uid: string;
  email: string;
  username: string;
  avatarUrls?: AvatarUrls;
  unreadNotificationsCount: number;
  emails: UserEmail[];
  /** Present only when true; absent means false. */
  superadmin?: boolean;
}

export type UserShortTypename = (typeof UserShortTypename)[keyof typeof UserShortTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserShortTypename = {
  UserShort: "UserShort",
} as const;

export interface UserShort {
  typename: UserShortTypename;
  name: string;
  uid: string;
  username: string;
  avatarUrls?: AvatarUrls;
}

export type SchoolDomainTypename = (typeof SchoolDomainTypename)[keyof typeof SchoolDomainTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SchoolDomainTypename = {
  SchoolDomain: "SchoolDomain",
} as const;

export interface SchoolDomain {
  typename: SchoolDomainTypename;
  uid: string;
  domain: string;
}

/**
 * How students are grouped into teams: `courses` (US: many courses per student), `departments` (one department per entry year) or `high_school` (one group per graduation year).
 */
export type SchoolKind = (typeof SchoolKind)[keyof typeof SchoolKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SchoolKind = {
  courses: "courses",
  departments: "departments",
  high_school: "high_school",
} as const;

export type ReviewStatus = (typeof ReviewStatus)[keyof typeof ReviewStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewStatus = {
  accepted: "accepted",
  on_review: "on_review",
  rejected: "rejected",
} as const;

export type SchoolTypename = (typeof SchoolTypename)[keyof typeof SchoolTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SchoolTypename = {
  School: "School",
} as const;

/**
 * Ops-only; null for non-superadmins.
 * @nullable
 */
export type SchoolMeta = { [key: string]: unknown } | null;

export interface School {
  typename: SchoolTypename;
  status: ReviewStatus;
  uid: string;
  name: string;
  /**
   * Abbreviation shown in place of the full name where present (MIT, UCLA).
   * @nullable
   */
  shortName: string | null;
  kind: SchoolKind;
  /** @nullable */
  address: string | null;
  /** @nullable */
  zipCode: string | null;
  /** @nullable */
  region: string | null;
  /** @nullable */
  countryCode: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  websiteUrl: string | null;
  /**
   * Source link the logo is downloaded from; the served images are logoUrls.
   * @nullable
   */
  logoUrl: string | null;
  /** @nullable */
  logoUrls: AvatarUrls;
  /**
   * Free-form ops notes.
   * @nullable
   */
  notes: string | null;
  /**
   * Ops-only; null for non-superadmins.
   * @nullable
   */
  meta: SchoolMeta;
  domains: SchoolDomain[];
  terms: Term[];
}

export type SchoolShortTypename = (typeof SchoolShortTypename)[keyof typeof SchoolShortTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SchoolShortTypename = {
  SchoolShort: "SchoolShort",
} as const;

export interface SchoolShort {
  typename: SchoolShortTypename;
  uid: string;
  name: string;
  /** @nullable */
  shortName: string | null;
}

export type ProfessorTypename = (typeof ProfessorTypename)[keyof typeof ProfessorTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfessorTypename = {
  Professor: "Professor",
} as const;

export interface Professor {
  typename: ProfessorTypename;
  uid: string;
  name: string;
}

export type ProfessorDetailedTypename =
  (typeof ProfessorDetailedTypename)[keyof typeof ProfessorDetailedTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfessorDetailedTypename = {
  Professor: "Professor",
} as const;

/**
 * The admin professors list entry: professor plus context.
 */
export interface ProfessorDetailed {
  typename: ProfessorDetailedTypename;
  uid: string;
  name: string;
  school: SchoolShort;
  coursesCount: number;
}

export type TermTypename = (typeof TermTypename)[keyof typeof TermTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermTypename = {
  Term: "Term",
} as const;

export interface Term {
  typename: TermTypename;
  uid: string;
  label: string;
  /** @nullable */
  startsOn: string | null;
  /** @nullable */
  endsOn: string | null;
}

export type CourseTypename = (typeof CourseTypename)[keyof typeof CourseTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseTypename = {
  Course: "Course",
} as const;

/**
 * @nullable
 */
export type CourseTerm = Term | null;

/**
 * Ops-only; null for non-superadmins.
 * @nullable
 */
export type CourseMeta = { [key: string]: unknown } | null;

/**
 * Superadmin-only (null otherwise); the student who submitted the course, null for ops-created ones.
 * @nullable
 */
export type CourseCreatedBy = UserShort | null;

/**
 * Superadmin-only (null otherwise); the account that owns the course team, or will once it is created.
 * @nullable
 */
export type CourseServiceAccount = UserShort | null;

/**
 * Superadmin-only (null otherwise); also null until the course team is created (first join or the admin button).
 * @nullable
 */
export type CourseTeam = TeamShort | null;

export interface Course {
  typename: CourseTypename;
  status: ReviewStatus;
  uid: string;
  name: string;
  /** @nullable */
  code: string | null;
  /** @nullable */
  subject: string | null;
  /** @nullable */
  term: CourseTerm;
  /** @nullable */
  externalId: string | null;
  /**
   * Free-form ops notes.
   * @nullable
   */
  notes: string | null;
  /**
   * Free-form course description shown to students.
   * @nullable
   */
  bio: string | null;
  /**
   * Ops-only; null for non-superadmins.
   * @nullable
   */
  meta: CourseMeta;
  professors: Professor[];
  school: SchoolShort;
  /**
   * Superadmin-only (null otherwise); the student who submitted the course, null for ops-created ones.
   * @nullable
   */
  createdBy: CourseCreatedBy;
  /**
   * Superadmin-only (null otherwise); the account that owns the course team, or will once it is created.
   * @nullable
   */
  serviceAccount: CourseServiceAccount;
  /**
   * Superadmin-only (null otherwise); also null until the course team is created (first join or the admin button).
   * @nullable
   */
  team: CourseTeam;
}

export type JoinCourseResultStatus =
  (typeof JoinCourseResultStatus)[keyof typeof JoinCourseResultStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JoinCourseResultStatus = {
  joined: "joined",
  "already-joined": "already-joined",
  "not-found": "not-found",
  "not-affiliated": "not-affiliated",
} as const;

/**
 * The joined team; null unless joined or already-joined.
 * @nullable
 */
export type JoinCourseResultTeam = TeamShort | null;

export interface JoinCourseResult {
  /** The requested uid, echoed back. */
  courseUid: string;
  status: JoinCourseResultStatus;
  /**
   * The joined team; null unless joined or already-joined.
   * @nullable
   */
  team: JoinCourseResultTeam;
}

export interface ImportCounts {
  created: number;
  updated: number;
}

export interface ImportCreatedCounts {
  created: number;
}

export interface ImportSummary {
  dryRun: boolean;
  schools: ImportCounts;
  domains: ImportCreatedCounts;
  terms: ImportCreatedCounts;
  courses: ImportCounts;
  professors: ImportCreatedCounts;
  errors: string[];
}

export type NotionPageTypename = (typeof NotionPageTypename)[keyof typeof NotionPageTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotionPageTypename = {
  NotionPage: "NotionPage",
} as const;

export interface NotionPage {
  typename: NotionPageTypename;
  id: string;
  title: string;
  children: NotionPage[];
}

export type UserEmailTypename = (typeof UserEmailTypename)[keyof typeof UserEmailTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEmailTypename = {
  UserEmail: "UserEmail",
} as const;

export type UserEmailKind = (typeof UserEmailKind)[keyof typeof UserEmailKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEmailKind = {
  primary: "primary",
  secondary: "secondary",
} as const;

export interface UserEmail {
  typename: UserEmailTypename;
  uid: string;
  email: string;
  kind: UserEmailKind;
  verified: boolean;
}

export type AuthTokenTypename = (typeof AuthTokenTypename)[keyof typeof AuthTokenTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthTokenTypename = {
  AuthToken: "AuthToken",
} as const;

export interface AuthToken {
  typename: AuthTokenTypename;
  id: string;
  title: string;
  /** @nullable */
  rawToken?: string | null;
}

export type MarimoTokenTypename = (typeof MarimoTokenTypename)[keyof typeof MarimoTokenTypename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarimoTokenTypename = {
  MarimoToken: "MarimoToken",
} as const;

export interface MarimoToken {
  typename: MarimoTokenTypename;
  /** JWT scoped to a single document, verified by the marimo gateway. */
  token: string;
  /** Expiration date of the marimo token. */
  expiresAt: string;
}

export type GetAiCreditsBalanceParams = {
  /**
   * The team whose credits to show; the user's personal team if omitted.
   */
  teamUid?: string;
};

export type GetAiCreditsBalance200Typename =
  (typeof GetAiCreditsBalance200Typename)[keyof typeof GetAiCreditsBalance200Typename];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAiCreditsBalance200Typename = {
  AiCreditsBalance: "AiCreditsBalance",
} as const;

/**
 * Only pools that grant the user credits on this team; a spent pool stays, at 0 remaining.
 */
export type GetAiCreditsBalance200Pools = {
  personalFree?: AiCreditBalance;
  subscription?: AiCreditBalance;
};

export type GetAiCreditsBalance200 = {
  typename: GetAiCreditsBalance200Typename;
  /** Only pools that grant the user credits on this team; a spent pool stays, at 0 remaining. */
  pools: GetAiCreditsBalance200Pools;
};

export type AiCreditsPreflightParams = {
  /**
   * What the request is about; its team's subscription pays first.
   */
  sourceType?: AiCreditsPreflightSourceType;
  sourceUid?: string;
};

export type AiCreditsPreflightSourceType =
  (typeof AiCreditsPreflightSourceType)[keyof typeof AiCreditsPreflightSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiCreditsPreflightSourceType = {
  Chat: "Chat",
  Document: "Document",
  Folder: "Folder",
} as const;

export type AiCreditsPreflight200 = {
  userUid: string;
  creditsAvailable: boolean;
};

export type ValidateHandleParams = {
  /**
   * Handle that needs to be validated.
   */
  handle: string;
};

export type GetAuthTestRequireAuth200 = {
  authenticated: boolean;
};

export type GetAuthTest200200 = {
  ok?: boolean;
};

/**
 * Auth token's :title.
 */
export type CreateAuthTokenBody = {
  title: string;
};

export type CreateAuthToken200 = {
  auth_token?: AuthToken;
};

export type DeleteAuthToken200 = {
  auth_token?: AuthToken;
};

export type CreateChatBodyKind = (typeof CreateChatBodyKind)[keyof typeof CreateChatBodyKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatBodyKind = {
  personal: "personal",
  collective: "collective",
} as const;

/**
 * Document's :uid (attaches the document) or team's :teamUid (creates a chat without documents), and chat's :kind.
 */
export type CreateChatBody = {
  uid?: string;
  teamUid?: string;
  kind?: CreateChatBodyKind;
  title?: string;
};

export type CreateChat200 = {
  chat?: Chat;
};

/**
 * Interlocutor's :uid for creating direct chat.
 */
export type CreateDirectChatBody = {
  uid?: string;
};

export type CreateDirectChat200 = {
  chat?: Chat;
};

export type GetChatParams = {
  /**
   * :cursor to fetch chat messages. Is set to current time when absent.
   */
  cursor?: string;
};

export type GetChat200 = {
  chat?: Chat;
};

export type UpdateChatBodyMeta = { [key: string]: string };

/**
 * New chat metadata (string→string map) and/or title.
 */
export type UpdateChatBody = {
  meta?: UpdateChatBodyMeta;
  title?: string;
};

export type UpdateChat200 = {
  chat?: ChatShort;
};

export type AttachChatDocument200 = {
  chat?: ChatShort;
};

export type DetachChatDocument200 = {
  chat?: ChatShort;
};

/**
 * :cursor to count unread chat messages by. Is set to current time when absent.
 */
export type MarkChatAsReadBody = {
  cursor?: string;
};

export type MarkChatAsRead200 = {
  chat?: UserSpecificChatBroadcast;
};

export type StopChatReply200 = {
  stopped: boolean;
};

export type ChatMentionableUsersParams = {
  /**
   * Prefix/substring the username or name of the people in scope should match.
   */
  query?: string;
};

export type ChatMentionableUsers200 = {
  users?: UserShort[];
};

export type RestoreChat200 = {
  chat?: Chat;
};

export type ListCoursesParams = {
  /**
   * Limits the list to one school.
   */
  school_uid?: string;
  /**
   * Limits the list to one of the school's terms (term-less courses are excluded); requires school_uid.
   */
  term_uid?: string;
  /**
   * Filters courses by name or code (substring match, ignoring whitespace and punctuation).
   */
  query?: string;
  /**
   * Page number (1-based); 100 per page.
   */
  page?: number;
  /**
   * Sort order. Default is newest first; `subject` sorts by subject (A–Z, courses without one last) then name, so pages can be grouped by subject.
   */
  order?: ListCoursesOrder;
  /**
   * Narrows the list to one review status.
   */
  status?: ListCoursesStatus;
};

export type ListCoursesOrder = (typeof ListCoursesOrder)[keyof typeof ListCoursesOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCoursesOrder = {
  subject: "subject",
} as const;

export type ListCoursesStatus = (typeof ListCoursesStatus)[keyof typeof ListCoursesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCoursesStatus = {
  accepted: "accepted",
  on_review: "on_review",
  rejected: "rejected",
} as const;

export type ListCourses200 = {
  courses: Course[];
  /** Total courses in scope (ignoring the query). */
  total: number;
  /** Courses matching the query (equals total when absent). */
  found: number;
  perPage: number;
};

/**
 * Arbitrary extra data stored verbatim.
 */
export type CreateCourseBodyMeta = { [key: string]: unknown };

export type CreateCourseBodyProfessorsItem = {
  name: string;
  externalId?: string;
};

export type CreateCourseBody = {
  schoolUid: string;
  name: string;
  code?: string;
  subject?: string;
  /** One of the school's terms; empty clears the term. */
  termUid?: string;
  externalId?: string;
  /** Free-form ops notes. */
  notes?: string;
  /** Free-form course description shown to students. */
  bio?: string;
  status?: ReviewStatus;
  /** Arbitrary extra data stored verbatim. */
  meta?: CreateCourseBodyMeta;
  /** Username of the existing user who owns the created team. */
  serviceAccountUsername: string;
  professors?: CreateCourseBodyProfessorsItem[];
};

export type CreateCourse201 = {
  course: Course;
};

export type ShowCourse200 = {
  course: Course;
};

/**
 * Arbitrary extra data stored verbatim.
 */
export type UpdateCourseBodyMeta = { [key: string]: unknown };

export type UpdateCourseBodyProfessorsItem = {
  name: string;
  externalId?: string;
};

export type UpdateCourseBody = {
  name?: string;
  code?: string;
  subject?: string;
  /** One of the school's terms; empty clears the term. */
  termUid?: string;
  externalId?: string;
  /** Free-form ops notes. */
  notes?: string;
  /** Free-form course description shown to students. */
  bio?: string;
  status?: ReviewStatus;
  /** Arbitrary extra data stored verbatim. */
  meta?: UpdateCourseBodyMeta;
  /** Username of the user who owns the course team; an existing team is handed over, and the previous service account leaves it. */
  serviceAccountUsername?: string;
  professors?: UpdateCourseBodyProfessorsItem[];
};

export type UpdateCourse200 = {
  course: Course;
};

export type JoinCoursesBody = {
  courseUids: string[];
};

export type JoinCourses200 = {
  results: JoinCourseResult[];
};

export type CreateCourseTeam200 = {
  course: Course;
};

export type SubmitCourseBody = {
  schoolUid: string;
  name: string;
  code?: string;
  /** One of the school's terms; the course runs term-less without it. */
  termUid?: string;
};

export type SubmitCourse201 = {
  course: Course;
};

export type CreateDocumentPermissionBodyKind =
  (typeof CreateDocumentPermissionBodyKind)[keyof typeof CreateDocumentPermissionBodyKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDocumentPermissionBodyKind = {
  regular: "regular",
  single_use_link: "single_use_link",
  reusable_link: "reusable_link",
} as const;

/**
 * Document's :uid, target user's :email or team's :permalink and permission's :scope and :kind attributes.
 */
export type CreateDocumentPermissionBody = {
  uid: string;
  email?: string;
  permalink?: string;
  kind?: CreateDocumentPermissionBodyKind;
  scope: string;
};

export type CreateDocumentPermission200 = {
  document_permission?: DocumentPermission;
};

/**
 * Document's :uid and permission's :scope attributes.
 */
export type SolicitDocumentPermissionBody = {
  uid: string;
  scope: string;
};

export type SolicitDocumentPermission200 = {
  document_permission?: DocumentPermission;
};

/**
 * Document permission's :token attribute.
 */
export type AcceptDocumentPermissionBody = {
  token: string;
};

/**
 * Document permission's :scope attribute.
 */
export type UpdateDocumentPermissionBody = {
  scope?: string;
};

export type UpdateDocumentPermission200 = {
  document_permission?: DocumentPermission;
};

export type ResentDocumentPermissionMail200 = {
  document_permission?: DocumentPermission;
};

/**
 * Document snapshot object
 */
export type CreateDocumentBodySnapshot = { [key: string]: unknown };

/**
 * Document's parent id. Should only be Folder.
 */
export type CreateDocumentBody = {
  title?: string;
  /** Base64 encoded Y.js document */
  y_doc?: string;
  /** Document snapshot object */
  snapshot?: CreateDocumentBodySnapshot;
  parentUid?: string;
  position?: number;
};

export type CreateDocument200 = {
  document?: Document;
};

export type FetchDocument200 = {
  document?: Document;
};

/**
 * Document snapshot object
 */
export type UpdateDocumentBodySnapshot = { [key: string]: unknown };

/**
 * Document's new attributes or parentUid/position.
 */
export type UpdateDocumentBody = {
  title?: string;
  /** Base64 encoded Y.js document */
  y_doc?: string;
  /** Document snapshot object */
  snapshot?: UpdateDocumentBodySnapshot;
  parentUid?: string;
  position?: number;
};

export type UpdateDocument200 = {
  document?: Document;
};

export type FetchDocumentUserPermissions200 = {
  document?: DocumentPermissions;
};

/**
 * Document's public flags.
 */
export type UpdateDocumentPublicFlagsBody = {
  publicRead?: boolean;
  publicWrite?: boolean;
};

export type UpdateDocumentPublicFlags200 = {
  document?: Document;
};

/**
 * Document's edit lock.
 */
export type UpdateDocumentLockBody = {
  locked?: boolean;
};

export type UpdateDocumentLock200 = {
  document?: Document;
};

/**
 * New document's parentUid/position.
 */
export type DuplicateDocumentBody = {
  parentUid?: string;
  position?: number;
};

export type DuplicateDocument200 = {
  document?: Document;
};

export type ListDocumentChats200 = {
  chats?: Chat[];
};

export type GetDocumentPermissionsAndRequests200 = {
  confirmed?: DocumentPermission[];
  unconfirmed?: DocumentPermission[];
};

export type SearchDocumentsParams = {
  /**
   * Query to search documents by.
   */
  query: string;
  /**
   * Team to search documents in.
   */
  team_uid?: string;
};

export type SearchDocuments200 = {
  documents?: DocumentSearchResult[];
};

export type FinishDocumentDuplication200 = {
  document?: Document;
};

export type DocumentMentionableUsersParams = {
  /**
   * Prefix/substring the username or name of the people in scope should match.
   */
  query?: string;
};

export type DocumentMentionableUsers200 = {
  users?: UserShort[];
};

/**
 * Folder's parent. Should only be Folder.
 */
export type CreateFolderBody = {
  title?: string;
  parentUid: string;
  position: number;
};

export type CreateFolder200 = {
  folder?: Folder;
};

/**
 * Folder's new attributes or parentUid/position.
 */
export type UpdateFolderBody = {
  title?: string;
  parentUid?: string;
  position?: number;
};

export type UpdateFolder200 = {
  folder?: Folder;
};

/**
 * Folder's new publicScope attribute.
 */
export type UpdateFolderPublicScopeBody = {
  publicScope?: string;
};

export type UpdateFolderPublicScope200 = {
  folder?: Folder;
};

/**
 * Folder's parentUid/position.
 */
export type DuplicateFolderBody = {
  parentUid?: string;
  position?: number;
};

export type DuplicateFolder200 = {
  folder?: Folder;
};

export type RecordAiCreditSpendBodySourceType =
  (typeof RecordAiCreditSpendBodySourceType)[keyof typeof RecordAiCreditSpendBodySourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordAiCreditSpendBodySourceType = {
  Chat: "Chat",
  Document: "Document",
} as const;

export type RecordAiCreditSpendBodyFeature =
  (typeof RecordAiCreditSpendBodyFeature)[keyof typeof RecordAiCreditSpendBodyFeature];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordAiCreditSpendBodyFeature = {
  chat_reply: "chat_reply",
  ocr: "ocr",
  file_import: "file_import",
} as const;

export type RecordAiCreditSpendBody = {
  userUid: string;
  sourceType: RecordAiCreditSpendBodySourceType;
  sourceUid: string;
  feature: RecordAiCreditSpendBodyFeature;
  provider: string;
  model: string;
  /** @minimum 0 */
  noCacheInputTokens?: number;
  /** @minimum 0 */
  cacheReadTokens?: number;
  /** @minimum 0 */
  cacheWriteTokens?: number;
  /** @minimum 0 */
  textOutputTokens?: number;
  /** @minimum 0 */
  reasoningTokens?: number;
  /** @minimum 0 */
  totalTokens?: number;
  /**
   * What the request actually cost, in USD.
   * @minimum 0
   */
  costUsd: number;
};

export type SyncDocumentMentionsBodyMentionsItem = {
  /** The mention node id, stable across undo/redo. */
  sourceNodeId: string;
  userUid: string;
  /** @nullable */
  authorUid?: string | null;
};

export type SyncDocumentMentionsBody = {
  mentions: SyncDocumentMentionsBodyMentionsItem[];
};

export type DeleteInvite200 = {
  invite?: Invite;
};

export type ResendInvite200 = {
  invite?: Invite;
};

export type AcceptInvite200 = {
  membership?: MembershipWithTeam;
};

export type UpdateMembershipBodyAccessLevel =
  (typeof UpdateMembershipBodyAccessLevel)[keyof typeof UpdateMembershipBodyAccessLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMembershipBodyAccessLevel = {
  owner: "owner",
  admin: "admin",
  member: "member",
  guest: "guest",
} as const;

/**
 * Memberships's :accessLevel attributes.
 */
export type UpdateMembershipBody = {
  accessLevel: UpdateMembershipBodyAccessLevel;
};

export type UpdateMembership200 = {
  membership?: Membership;
};

export type CreateMessageBodyMeta = { [key: string]: string };

export type CreateMessageBodyMentionsItem = {
  sourceNodeId: string;
  userUid: string;
};

/**
 * Chat's :uid and message's :body, :fileKeys, :meta and :mentions attributes.
 */
export type CreateMessageBody = {
  uid: string;
  body?: string;
  clientMessageUid?: string;
  fileKeys?: string[];
  meta?: CreateMessageBodyMeta;
  mentions?: CreateMessageBodyMentionsItem[];
};

export type CreateMessage200 = {
  message?: Message;
};

export type UpdateMessageBodyMeta = { [key: string]: string };

export type UpdateMessageBodyMentionsItem = {
  sourceNodeId: string;
  userUid: string;
};

/**
 * Messages's :body attribute, and the :mentions the edited body still contains.
 */
export type UpdateMessageBody = {
  body: string;
  meta?: UpdateMessageBodyMeta;
  mentions?: UpdateMessageBodyMentionsItem[];
};

export type UpdateMessage200 = {
  message?: Message;
};

export type DeleteMessage200 = {
  message?: Message;
};

/**
 * :ids of notifications to mark as read.
 */
export type MarkNotificationsAsReadBody = {
  ids: string[];
};

export type NotionConnectionStatus200 = {
  connected?: boolean;
  /** @nullable */
  workspace_name?: string | null;
};

/**
 * Notion oauth code and redirectUri.
 */
export type NotionConnectBody = {
  code: string;
  redirectUri: string;
};

export type FetchNotionPages200 = {
  pages?: NotionPage[];
};

/**
 * Notion pageIds and new documents' parentUid/position.
 */
export type ImportNotionPagesBody = {
  pageIds: string[];
  parentUid: string;
  position?: number;
};

export type ImportNotionPages200 = {
  documents?: DocumentShort[];
};

export type NotionDisconnect200 = {
  disconnected?: boolean;
};

export type ListProfessorsParams = {
  /**
   * Limits the list to one school.
   */
  school_uid?: string;
  /**
   * Filters professors by name (substring match).
   */
  query?: string;
  /**
   * Page number (1-based); 100 per page.
   */
  page?: number;
};

export type ListProfessors200 = {
  professors: ProfessorDetailed[];
  /** Total professors in scope (ignoring the query). */
  total: number;
  /** Professors matching the query (equals total when absent). */
  found: number;
  perPage: number;
};

export type CreateProfessorBody = {
  schoolUid: string;
  name: string;
};

export type CreateProfessor201 = {
  professor: ProfessorDetailed;
};

export type UpdateProfessorBody = {
  name: string;
};

export type UpdateProfessor200 = {
  professor: ProfessorDetailed;
};

export type RegisterPushDeviceBodyPlatform =
  (typeof RegisterPushDeviceBodyPlatform)[keyof typeof RegisterPushDeviceBodyPlatform];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterPushDeviceBodyPlatform = {
  ios: "ios",
  android: "android",
} as const;

export type RegisterPushDeviceBody = {
  /** FCM registration token. */
  token: string;
  platform: RegisterPushDeviceBodyPlatform;
};

export type UnregisterPushDeviceBody = {
  token: string;
};

export type CreateReactionParams = {
  /**
   * Reaction's :emoji attribute.
   */
  emoji: string;
};

export type CreateReaction200 = {
  reaction?: Reaction;
};

export type DeleteReactionParams = {
  /**
   * Reaction's :emoji attribute.
   */
  emoji: string;
};

export type DeleteReaction200 = {
  reaction?: Reaction;
};

export type ListReferralsParams = {
  /**
   * Limits the list to one user.
   */
  username?: string;
  /**
   * Filters referrals by token (substring match).
   */
  query?: string;
  /**
   * Page number (1-based); 100 per page.
   */
  page?: number;
};

export type ListReferrals200 = {
  referrals: Referral[];
  /** Total referrals in scope (ignoring the query). */
  total: number;
  /** Referrals matching the query (equals total when absent). */
  found: number;
  perPage: number;
};

export type CreateReferral200 = {
  referral?: Referral;
};

/**
 * Referral's custom :token, :info and :expiresAt attributes
 */
export type AdminCreateReferralBody = {
  token: string;
  info?: string;
  /** @nullable */
  expiresAt?: string | null;
};

export type AdminCreateReferral200 = {
  referral?: Referral;
};

/**
 * Referral's custom :token, :info and :expiresAt attributes
 */
export type UpdateReferralBody = {
  token: string;
  info: string;
  /** @nullable */
  expiresAt?: string | null;
};

export type UpdateReferral200 = {
  referral: Referral;
};

/**
 * JSON file; the structure is documented in docs/plans/student-onboarding.md.
 */
export type CreateSchoolImportBodyImport = {
  file: Blob;
};

export type CreateSchoolImportBody = {
  /** JSON file; the structure is documented in docs/plans/student-onboarding.md. */
  import: CreateSchoolImportBodyImport;
  /** Validate and report without saving anything. */
  dryRun?: boolean;
  /** Username of the existing user who owns newly created course teams; required only when the file adds a course. */
  serviceAccountUsername?: string;
};

export type CreateSchoolImport200 = {
  import: ImportSummary;
};

export type ListSchoolsParams = {
  /**
   * Filters schools by name or short name: typo-tolerant trigram match, closest first.
   */
  query?: string;
  /**
   * Page number (1-based); 100 per page.
   */
  page?: number;
  /**
   * Returns every school unpaginated (the admin pickers); ignores page.
   */
  all?: boolean;
  /**
   * Narrows the list to the schools the current user is affiliated with: a verified email on one of their domains, directly or on a subdomain. Several schools may share a domain, so the list can hold more than one per email; `total` and `found` then count affiliated schools only.
   */
  affiliated?: boolean;
  /**
   * Narrows the list to one review status.
   */
  status?: ListSchoolsStatus;
};

export type ListSchoolsStatus = (typeof ListSchoolsStatus)[keyof typeof ListSchoolsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListSchoolsStatus = {
  accepted: "accepted",
  on_review: "on_review",
  rejected: "rejected",
} as const;

export type ListSchools200 = {
  schools: School[];
  /** Total schools (ignoring the query). */
  total: number;
  /** Schools matching the query (equals total when absent). */
  found: number;
  perPage: number;
};

/**
 * Arbitrary extra data stored verbatim.
 */
export type CreateSchoolBodyMeta = { [key: string]: unknown };

export type CreateSchoolBodyTermsItem = {
  /** Present to update an existing term, absent to create. */
  uid?: string;
  label: string;
  startsOn?: string;
  endsOn?: string;
};

export type CreateSchoolBody = {
  name: string;
  /** Abbreviation (MIT, UCLA) shown in place of the full name. */
  shortName?: string;
  kind?: SchoolKind;
  address?: string;
  zipCode?: string;
  region?: string;
  countryCode?: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  websiteUrl?: string;
  /** Image link to download the logo from (async). */
  logoUrl?: string;
  /** Free-form ops notes. */
  notes?: string;
  status?: ReviewStatus;
  /** Arbitrary extra data stored verbatim. */
  meta?: CreateSchoolBodyMeta;
  domains?: string[];
  terms?: CreateSchoolBodyTermsItem[];
};

export type CreateSchool201 = {
  school: School;
};

export type SubmitSchoolBodyTermsItem = {
  label: string;
  startsOn?: string;
  endsOn?: string;
};

export type SubmitSchoolBody = {
  name: string;
  countryCode?: string;
  /** Uid of the submitter's verified email; its domain becomes the school's. */
  emailUid: string;
  /** Terms to start the school with; the courses step needs one. */
  terms?: SubmitSchoolBodyTermsItem[];
};

export type SubmitSchool201 = {
  school: School;
};

export type CheckSchoolDomainParams = {
  /**
   * Domain part of the address the student is about to verify.
   */
  domain: string;
};

/**
 * Why the domain cannot become a new school's, if so.
 * @nullable
 */
export type CheckSchoolDomain200Rejection =
  | (typeof CheckSchoolDomain200Rejection)[keyof typeof CheckSchoolDomain200Rejection]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckSchoolDomain200Rejection = {
  public_email_domain: "public_email_domain",
  relay_email_domain: "relay_email_domain",
} as const;

export type CheckSchoolDomain200 = {
  /**
   * Why the domain cannot become a new school's, if so.
   * @nullable
   */
  rejection: CheckSchoolDomain200Rejection;
  /** Up to five schools already using the domain, accepted ones first, then by name: suggestions for the student. */
  schools: SchoolShort[];
};

export type ShowSchool200 = {
  school: School;
};

/**
 * Arbitrary extra data stored verbatim.
 */
export type UpdateSchoolBodyMeta = { [key: string]: unknown };

export type UpdateSchoolBodyTermsItem = {
  /** Present to update an existing term, absent to create. */
  uid?: string;
  label: string;
  startsOn?: string;
  endsOn?: string;
};

export type UpdateSchoolBody = {
  name?: string;
  /** Abbreviation (MIT, UCLA) shown in place of the full name. */
  shortName?: string;
  kind?: SchoolKind;
  address?: string;
  zipCode?: string;
  region?: string;
  countryCode?: string;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  websiteUrl?: string;
  /** Image link to download the logo from (async). */
  logoUrl?: string;
  /** Free-form ops notes. */
  notes?: string;
  status?: ReviewStatus;
  /** Arbitrary extra data stored verbatim. */
  meta?: UpdateSchoolBodyMeta;
  domains?: string[];
  terms?: UpdateSchoolBodyTermsItem[];
};

export type UpdateSchool200 = {
  school: School;
};

/**
 * Logo image to attach to the school.
 */
export type UploadSchoolLogoBodyLogo = {
  file: Blob;
};

export type UploadSchoolLogoBody = {
  /** Logo image to attach to the school. */
  logo: UploadSchoolLogoBodyLogo;
};

export type UploadSchoolLogo201 = {
  school: School;
};

export type ListAffiliatedSchools200 = {
  schools: School[];
};

export type ListSubscriptionPlans200 = {
  subscriptionPlans: SubscriptionPlan[];
};

export type CreateSubscriptionPlanBodyKind =
  (typeof CreateSubscriptionPlanBodyKind)[keyof typeof CreateSubscriptionPlanBodyKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSubscriptionPlanBodyKind = {
  personal: "personal",
  team: "team",
} as const;

export type CreateSubscriptionPlanBodyInterval =
  (typeof CreateSubscriptionPlanBodyInterval)[keyof typeof CreateSubscriptionPlanBodyInterval];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSubscriptionPlanBodyInterval = {
  month: "month",
} as const;

export type CreateSubscriptionPlanBody = {
  name: string;
  kind: CreateSubscriptionPlanBodyKind;
  interval: CreateSubscriptionPlanBodyInterval;
  current?: boolean;
  aiCredits: number;
  priceCents: number;
};

export type CreateSubscriptionPlan201 = {
  subscriptionPlan: SubscriptionPlan;
};

export type ListAvailableSubscriptionPlans200 = {
  subscriptionPlans: SubscriptionPlan[];
};

export type GetSubscriptionPlan200 = {
  subscriptionPlan: SubscriptionPlan;
};

export type UpdateSubscriptionPlanBody = {
  name?: string;
  current?: boolean;
};

export type UpdateSubscriptionPlan200 = {
  subscriptionPlan: SubscriptionPlan;
};

export type GetCurrentSubscriptionParams = {
  /**
   * Team's :uid attribute; defaults to the user's personal team.
   */
  teamUid?: string;
};

/**
 * @nullable
 */
export type GetCurrentSubscription200Subscription = Subscription | null;

export type GetCurrentSubscription200 = {
  /** @nullable */
  subscription: GetCurrentSubscription200Subscription;
};

export type CheckoutSubscriptionBody = {
  subscriptionPlanUid: string;
  /** Team's :uid attribute; defaults to the user's personal team. A personal team takes a personal plan, any other team a team plan. */
  teamUid?: string;
  /** Web app path Stripe sends the browser back to after Checkout completes or is canceled; defaults to the home page. */
  returnPath?: string;
};

export type CheckoutSubscription200 = {
  /** Stripe-hosted Checkout URL to redirect the browser to. */
  url: string;
};

/**
 * Team's :title, :bio and :permalink attributes.
 */
export type CreateTeamBody = {
  title: string;
  bio?: string;
  permalink?: string;
};

export type CreateTeam200 = {
  team?: Team;
};

export type GetTeam200 = {
  team?: Team;
};

/**
 * Team's :title, :bio and :permalink attributes.
 */
export type UpdateTeamBody = {
  title: string;
  bio?: string;
  newPermalink: string;
};

export type UpdateTeam200 = {
  team?: TeamShort;
};

export type GetTeamShort200 = {
  team?: TeamShort;
};

export type GetTeamCoursePreview200 = {
  coursePreview: TeamCoursePreview;
};

export type TeamMemberships200 = {
  memberships?: Membership[];
};

export type ListTeamChats200 = {
  chats?: Chat[];
};

export type ListTeamDeletedChats200 = {
  chats?: ChatShort[];
};

export type CreateInviteBodyKind = (typeof CreateInviteBodyKind)[keyof typeof CreateInviteBodyKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInviteBodyKind = {
  regular: "regular",
  single_use_link: "single_use_link",
  reusable_link: "reusable_link",
} as const;

/**
 * Email or user id to send invite to.
 */
export type CreateInviteBody = {
  email?: string;
  username?: string;
  kind?: CreateInviteBodyKind;
};

export type CreateInvite200 = {
  invite?: Invite;
};

export type TeamInvites200 = {
  invites?: Invite[];
};

/**
 * Avatar that needs to be attached to team.
 */
export type UploadTeamAvatarBodyAvatar = {
  file: Blob;
};

export type UploadTeamAvatarBody = {
  /** Avatar that needs to be attached to team. */
  avatar: UploadTeamAvatarBodyAvatar;
};

export type UploadTeamAvatar201 = {
  team?: Team;
};

export type FollowTeam200 = {
  follow?: Follow;
};

export type UnfollowTeam200 = {
  follow?: Follow;
};

export type TeamSearchParams = {
  /**
   * Query that permalinks/titles should match.
   */
  query: string;
};

export type TeamSearch200 = {
  teams?: TeamShort[];
};

export type OpenTeamBillingPortalBody = {
  /** Web app path Stripe sends the browser back to when the user leaves the portal; defaults to the home page. */
  returnPath?: string;
};

export type OpenTeamBillingPortal200 = {
  /** Stripe-hosted Billing Portal URL to redirect the browser to. */
  url: string;
};

export type UploadDirectBodyBlob = {
  filename: string;
  byteSize: number;
  checksum: string;
  contentType: string;
};

/**
 * Blob params.
 */
export type UploadDirectBody = {
  blob: UploadDirectBodyBlob;
};

export type GetFileSignedUrlParams = {
  /**
   * Sign the URL to save the file as an attachment instead of displaying it.
   */
  download?: boolean;
};

export type AttachUploadParams = {
  /**
   * Uid of the document or chat the blob was copied from. Required when the blob is already attached elsewhere.
   */
  sourceUid?: string;
  /**
   * Type of the :sourceUid entity. Defaults to "document" (legacy content references documents only).
   */
  sourceType?: AttachUploadSourceType;
};

export type AttachUploadSourceType =
  (typeof AttachUploadSourceType)[keyof typeof AttachUploadSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachUploadSourceType = {
  document: "document",
  chat: "chat",
} as const;

/**
 * Email address to add. Re-posting an unverified address resends the code.
 */
export type CreateUserEmailBody = {
  email: string;
};

export type CreateUserEmail200 = {
  user?: CurrentUser;
};

export type VerifyUserEmailBody = {
  code: string;
};

export type VerifyUserEmail200 = {
  user?: CurrentUser;
};

export type DeleteUserEmail200 = {
  user?: CurrentUser;
};

export type GetCurrentUser200 = {
  user?: CurrentUser;
};

export type CreateCurrentUserBody = {
  username: string;
  name?: string;
  googleAccessToken?: string;
  referralToken?: string;
};

export type CreateCurrentUser200 = {
  user?: CurrentUser;
};

export type UpdateCurrentUserBody = {
  username?: string;
  name?: string;
  googleAccessToken?: string;
};

export type UpdateCurrentUser200 = {
  user?: CurrentUser;
};

export type ValidateUsernameParams = {
  /**
   * Username that needs to be validated.
   */
  username: string;
};

/**
 * Query params added to the link, for the browser that opens it: the requesting browser's anonymous PostHog id (`ph_did`) and the promo it came through (`via`). Unknown keys are dropped.
 */
export type SendSignInLinkBodyTrackingParams = {
  ph_did?: string;
  via?: string;
};

export type SendSignInLinkBody = {
  email: string;
  /** Query params added to the link, for the browser that opens it: the requesting browser's anonymous PostHog id (`ph_did`) and the promo it came through (`via`). Unknown keys are dropped. */
  trackingParams?: SendSignInLinkBodyTrackingParams;
};

export type UserTeams200 = {
  teams?: TeamShort[];
};

export type UserAuthTokens200 = {
  auth_tokens?: AuthToken[];
};

export type PendingInvites200 = {
  invites?: Invite[];
};

export type ApplyOnboardingTemplatesBodyRolesItem =
  (typeof ApplyOnboardingTemplatesBodyRolesItem)[keyof typeof ApplyOnboardingTemplatesBodyRolesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplyOnboardingTemplatesBodyRolesItem = {
  researcher: "researcher",
  engineer: "engineer",
  student: "student",
  educator: "educator",
  other: "other",
} as const;

export type ApplyOnboardingTemplatesBody = {
  /** Empty array falls back to "other". */
  roles?: ApplyOnboardingTemplatesBodyRolesItem[];
};

export type UserSearchParams = {
  /**
   * Query that usernames/names should match.
   */
  query: string;
};

export type UserSearch200 = {
  users?: UserShort[];
};

export type MarkCurrentUserChatsAsReadBody = {
  scopeResourceUid?: string;
};

export type GetCurrentUserNotificationsParams = {
  /**
   * :cursor to fetch notifications. Is set to current time when absent.
   */
  cursor?: string;
};

export type GetCurrentUserNotifications200 = {
  notifications: Notification[];
  hasMore: boolean;
};

export type RecentDocumentsParams = {
  /**
   * Uid of the team the documents should belong to.
   */
  teamUid: string;
  /**
   * Maximum number of documents to return. Capped at 10.
   */
  limit?: number;
};

export type RecentDocuments200 = {
  documents: DocumentShort[];
};

export type GetCurrentUserDirectAndGroupChats200 = {
  chats?: Chat[];
};

export type ListSuperadmins200 = {
  superadmins: UserShort[];
};

export type CreateSuperadminBody = {
  username: string;
};

export type CreateSuperadmin201 = {
  user: UserShort;
};
